/**
 * Schedule placeholders that are not patients. RevolutionEHR books a blocked
 * slot as an appointment for a patient literally named "TIME BLOCK"; the
 * Cockpit hides those rows, and the Benefits Capture day builder never counts
 * them as visits. One rule, shared so the two readers cannot drift.
 */

const PLACEHOLDER_NAME = 'TIME BLOCK'

export function isPlaceholderPatient(p: {
  firstName?: string | null
  lastName?: string | null
}): boolean {
  if ((p.firstName ?? '').trim().toUpperCase() === PLACEHOLDER_NAME) return true
  if ((p.lastName ?? '').trim().toUpperCase() === PLACEHOLDER_NAME) return true
  return false
}

export function isRealPatient(p: { firstName?: string | null; lastName?: string | null }): boolean {
  return !isPlaceholderPatient(p)
}
